<template>
    <div id="project-view-history" class="single" v-if="viewed.length">
        <div class="flex">
            <div v-for="(viewedItem, v) in viewed" :key="v">
                <span v-if="v === 0"><b>Viewed: </b></span>
                <span v-if="v > 0">, </span>
                <span class="btn link" @click="Navigate(v)">{{ viewedItem.name }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import { ASSETS } from "@/assets/JS/Assets.js";

export default {
    name: "ProjectViewHistory",
    props: { viewed: Array },
    methods: {
        Navigate: function(index) {
            const viewedProject = this.viewed[index];
            const { projectID, name, timelineProjectMapID } = viewedProject;
            const project = ASSETS.CleanURL(name);
            this.$router.push({
                name: "Project",
                params: { name: project },
                meta: {
                    id: projectID,
                    timelineProjectMapID
                }
            });
            this.$emit("project", {
                projectID,
                name,
                timelineProjectMapID
            });
        }
    },
    emits: [ "project" ]
};
</script>